




































import { defineComponent, ref } from '@nuxtjs/composition-api';
import ReviewStar from '~/components/atoms/Review/ReviewStar/ReviewStar.vue';

export default defineComponent({
  name: 'ReviewStarRating',
  components: {
    ReviewStar,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    required: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    valid: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const selectedRating = ref(props.value);
    const hoverRating = ref(0);

    const mouseOverHandle = (rating:number) => {
      hoverRating.value = rating;
    };

    return {
      selectedRating,
      hoverRating,
      mouseOverHandle,
    };
  },
});
